import {
  HeadingText,
  ParagraphText,
  TextAction,
} from '@leagueplatform/genesis-core';
import { useIntl, FormattedMessage } from '@leagueplatform/locales';

export const AmplarContactUsContent = () => {
  const { formatMessage } = useIntl();
  const email = formatMessage({ id: 'STR_CONTACT_US_EMAIL' });

  return (
    <>
      <HeadingText level="2" size="xl" css={{ typography: '$headingTwo' }}>
        {formatMessage({ id: 'STR_CONTACT_US_TITLE' })}
      </HeadingText>
      <ParagraphText>
        <FormattedMessage
          id="STR_CONTACT_US_BODY"
          values={{
            br: <br />,
            emailLink: (
              <TextAction href={`mailto:${email}`}>{email}</TextAction>
            ),
          }}
        />
      </ParagraphText>
    </>
  );
};
